import Button from 'components/Button';
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { PlusOutlined } from '@ant-design/icons';

import DataGrid from 'components/DataGrid';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';
import { DatePicker, Button as AntdButton, Typography } from 'antd';

import DF from 'DisplayFramework';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import {
  findPaymentByAnyRefOrStatusOrDate,
  FindPaymentByAnyRefOrStatusOrDateParams,
  PAYListResponse,
} from 'services/PaymentServices';
import SIStatusTag from 'pages/SupplierInvoice/SIStatusTag';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { dateToString } from 'utils/utils2';
import RouterLink from 'components/RouterLink';
import ParListSelect from 'components/ParListSelect';
import { toCurrency } from 'utils/utils';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IActions from 'icons/IActions';
export type PayListProps = Pick<DataGridProps<any>, 'rowSelection'> & {
  isModal?: string;
  onSelect?: (item: PAYListResponse) => void;
  hideCIListModal?: () => void;
  hideCol?: boolean;
  hideExtraAction?: boolean;
  propref?:string
};
const PayList = (props: PayListProps) => {
  const { onSelect } = props;
  const history = useHistory();

  const { rowSelection } = props;
  const [searchs, setsearchs] = useState(false);
  const initialSearchParams: FindPaymentByAnyRefOrStatusOrDateParams = {
    cireference: '',
    ctreference: props.propref??'',
    datemax: '',
    datemin: '',
    payallstat: '',
    paydocreference: '',
    paymode: '',
    payreference: '',
    paystatus: '',
    sireference: '',
    tpname: '',
    tpreference: '',
    paydirection: '',
    currcode: '',
    paytype: '',
  };

  const [searchParams, setSearchParams] =
    useState<FindPaymentByAnyRefOrStatusOrDateParams>(initialSearchParams);

  const { data, refetch, isFetching } = useQuery(
    ['findPaymentByAnyRefOrStatusOrDate', searchParams],
    () =>
      findPaymentByAnyRefOrStatusOrDate(searchParams).then((res) => {
        setsearchs(false);
        return res.list || [];
      }),
    { refetchOnMount: false, enabled: searchs }
  );

  const columns = useMemo<DataGridColDef<PAYListResponse>[]>(
    () => [
      {
        dataIndex: 'payreference',
        width: 80,
        fixed: 'left',
        filtrable: true,

        render: (value, record) =>
          onSelect ? (
            <Typography.Link onClick={() => onSelect(record)}>
              {value}
            </Typography.Link>
          ) : (
            <RouterLink to={`/payment/${record.payid}`}>{value}</RouterLink>
          ),
      },
      {
        comcode: 'paystatuslabel',
        dataIndex: 'paystatus',
        filtrable: 'paystatus',
        filterComponent: <ParListSelect parcode="PAYMSTATUS" />,
        width: 80,
        render: (value, record) => (
          <SIStatusTag
            status={record.paystatus}
            statuslabel={record.statuslabel}
            key={record.payid}
          />
        ),
      },
      {
        dataIndex: 'tpname',
        filtrable: true,

        width: 120,
      },
      {
        dataIndex: 'paytype',
        filtrable: true,
        filterComponent: <ParListSelect parcode="PAYMTYPE" />,
        width: 80,
      },
      {
        dataIndex: 'paydirection',
        filtrable: true,
        filterComponent: <ParListSelect parcode="PAYDIR" />,
        width: 80,
      },
      {
        dataIndex: 'paynbrepresentation',
        width: 120,
      },
      {
        dataIndex: 'payamount',
        filtrable: 'currcode',
        filterComponent: <ParListSelect parcode="CURRENCY" />,
        width: 120,
        render: (val, record) => toCurrency(val, record.currcode ?? localStorage.getItem('currcode') ?? ''),
      },

      {
        dataIndex: 'payremainingamount',

        width: 120,
        render: (val, record) => toCurrency(val, record.currcode ?? localStorage.getItem('currcode') ?? ''),
      },
      {
        comcode: 'InvoiceRef',
        dataIndex: 'cireference',
        filtrable: true,

        width: 120,
        render: (value, record) => (
          <>
            {record.cireference && record.ciid && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.cireference}</a>
                )}
                modal={({ setVisible, visible }) => (
                  <CIDetail
                    ciid={record.ciid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}
            {record.sireference && record.siid && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.sireference}</a>
                )}
                modal={({ setVisible, visible }) => (
                  <SIDetail
                    siid={record.siid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}{' '}
            {(record.siid == null || record.siid === 0) && 
              (record.ciid == null || record.ciid === 0) && 
              value}
          </>
        ),
      },
      {
        dataIndex: 'ctreference',
        filtrable: true,

        width: 120,
      },
      {
        dataIndex: 'paydocdate',
        comcode: 'paydocdate',
        filterMultiple: true,
        filtrable: 'datemaxdatemin',
        filterComponent: (
          <React.Fragment>
            <DatePicker name="datemin" placeholder="date min" />
            <DatePicker name="datemax" placeholder="date max" />
          </React.Fragment>
        ),
        width: 100,
        render: (e) => moment(e).format('YYYY-MM-DD'),
      },

      {
        comcode: 'Action',
        key: 'operation',
        fixed: 'right',
        width: 80,
        render: (record) => (
          <TasksListPopover
            entityId={record.payid}
            entityReference={record?.payreference}
            entityName="PAYMENT"
            title={record?.payreference + ' - ' + record?.tpname}
            onClose={refetch}
          >
            <AntdButton
              icon={<IActions height="15px" width="15px" />}
              size="small"
            >
              <GetLabel label="actions" />
            </AntdButton>
          </TasksListPopover>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParams, refetch]
  );

  return (
    <DF.Provider pagcode="paylist">
      <DataGrid
        rowKey="payid"
        dataSource={data}
        titleComcode="paymentslist"
        columns={
          !props.hideCol
            ? columns
            : columns.filter((ea) => ea.key !== 'operation')
        }
        hideExtraAction={props.hideExtraAction}
        onSearch={(value) => {
          setSearchParams({
            ...value,
            datemin: dateToString(value.datemin),
            datemax: dateToString(value.datemax),
          });
          setsearchs(true);
        }}
        componentName="payment_list"
        initialSearchValues={initialSearchParams}
        isLoading={isFetching}
        rowSelection={rowSelection}
        extraActions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => history.push(`/payment/create`)}
            comcode="add"
          />
        }
      />
    </DF.Provider>
  );
};

export default PayList;
